import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gltf",
  "use": "icon-gltf-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"https://www.w3.org/2000/svg\" xmlns:xlink=\"https://www.w3.org/1999/xlink\" id=\"icon-gltf\">\n  <path d=\"M1024 768l-512 256-512-256V256l512-256 512 256v512z m-448 58.368l320-146.752V389.568L576 536.384v289.984z m-448-146.752l320 146.752V536.384L128 389.568v290.048z m384-524.16L213.632 288 512 420.544 810.368 288z\" p-id=\"12660\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/gltf.svg
// module id = 5d1N
// module chunks = 12